import React, { useEffect, useRef } from 'react'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Benifits = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);
  
    useEffect(() => {
      const cards = cardRefs.current;
  
      const initialPositions = [
        { x: 0, y: 100, opacity: 0 },
        { x: 0, y: 150, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
      ];
  
      cards.forEach((card, index) => {
        gsap.fromTo(
          card,
          initialPositions[index], 
          {
            x: 0,
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 100%",
              toggleActions: "play none none none",
            //   markers: true
            },
          }
        );
  
        gsap.set(card, { transformOrigin: "center" });
  
        card.addEventListener("mouseenter", () => {
          gsap.to(card, { scale: 1.05, duration: 0.3 });
        });
  
        card.addEventListener("mouseleave", () => {
          gsap.to(card, { scale: 1, duration: 0.3 });
        });
      });
    }, []);
    return (
        <>
            <section className='benifitsprnt'>
                <div className="custom-container" ref={sectionRef}>
                    <div className="beniftschlprnt">
                        <h2>Key Benefits</h2>
                        <div className="benifitscardsprnt">
                            <div className="cardonebenifits"  ref={(el) => (cardRefs.current[0] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg.png" alt="" />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                    <g clip-path="url(#clip0_1199_14826)">
                                        <path d="M36.6666 23.8334C36.6666 33 30.2499 37.5834 22.6233 40.2417C22.2239 40.3771 21.7901 40.3706 21.3949 40.2234C13.7499 37.5834 7.33325 33 7.33325 23.8334V11.0001C7.33325 10.5138 7.52641 10.0475 7.87022 9.70369C8.21404 9.35987 8.68036 9.16672 9.16659 9.16672C12.8333 9.16672 17.4166 6.96672 20.6066 4.18005C20.995 3.84822 21.4891 3.66589 21.9999 3.66589C22.5108 3.66589 23.0049 3.84822 23.3933 4.18005C26.6016 6.98505 31.1666 9.16672 34.8333 9.16672C35.3195 9.16672 35.7858 9.35987 36.1296 9.70369C36.4734 10.0475 36.6666 10.5138 36.6666 11.0001V23.8334Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M0.786621 23H43.213" stroke="#E0ECFA" stroke-width="2.5" stroke-linecap="square" stroke-linejoin="round" />
                                        <path d="M16.5 22L20.1667 25.6667L27.5 18.3334" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1199_14826">
                                            <rect width="44" height="44" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <h3>Complete Privacy</h3>
                                <p>Your browsing data is encrypted, ensuring no one tracks your activity.</p>
                            </div>
                            <div className="cardonebenifits"  ref={(el) => (cardRefs.current[1] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg2.png" alt="" />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                    <path d="M13.89 13.89L4.5 16.5V21L25.71 25.71" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" />
                                    <path d="M31.4999 23.01V9L20.5349 12.045" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" />
                                    <path d="M17.5624 24.4112C17.4265 24.988 17.1784 25.5324 16.8321 26.0132C16.4858 26.4941 16.0482 26.9021 15.5443 27.2139C15.0404 27.5257 14.48 27.7352 13.8951 27.8304C13.3102 27.9256 12.7123 27.9047 12.1355 27.7688C11.5587 27.6329 11.0143 27.3848 10.5334 27.0385C10.0525 26.6922 9.64449 26.2547 9.33271 25.7507C9.02093 25.2468 8.81145 24.6864 8.71625 24.1015C8.62104 23.5166 8.64197 22.9187 8.77785 22.3419" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                    <path d="M3 3L33 33" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                </svg>
                                <h3>Ad-Free Experience</h3>
                                <p>Block intrusive ads for a cleaner, faster, and distraction-free experience.</p>
                            </div>
                            <div className="cardonebenifits"  ref={(el) => (cardRefs.current[2] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg3.png" alt="" />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
                                    <path d="M8.66673 30.3333C8.25672 30.3347 7.85473 30.2197 7.50746 30.0017C7.1602 29.7838 6.8819 29.4717 6.70492 29.1019C6.52794 28.732 6.45953 28.3196 6.50765 27.9124C6.55576 27.5052 6.71842 27.12 6.97673 26.8016L28.4267 4.70161C28.5876 4.51589 28.8069 4.39039 29.0485 4.3457C29.2902 4.30102 29.5398 4.33981 29.7565 4.4557C29.9732 4.5716 30.144 4.75772 30.241 4.98351C30.3379 5.2093 30.3552 5.46135 30.2901 5.69828L26.1301 18.7416C26.0074 19.0699 25.9662 19.4231 26.01 19.7708C26.0538 20.1185 26.1813 20.4504 26.3816 20.738C26.5819 21.0257 26.8489 21.2604 27.1598 21.4221C27.4707 21.5839 27.8163 21.6678 28.1667 21.6666H43.3334C43.7434 21.6652 44.1454 21.7802 44.4927 21.9982C44.8399 22.2161 45.1182 22.5282 45.2952 22.898C45.4722 23.2679 45.5406 23.6803 45.4925 24.0875C45.4444 24.4947 45.2817 24.8799 45.0234 25.1983L23.5734 47.2983C23.4125 47.484 23.1932 47.6095 22.9516 47.6542C22.71 47.6989 22.4603 47.6601 22.2436 47.5442C22.027 47.4283 21.8561 47.2422 21.7592 47.0164C21.6622 46.7906 21.6449 46.5385 21.7101 46.3016L25.8701 33.2583C25.9927 32.93 26.0339 32.5768 25.9901 32.2291C25.9463 31.8814 25.8188 31.5495 25.6185 31.2619C25.4183 30.9742 25.1512 30.7395 24.8403 30.5778C24.5294 30.416 24.1839 30.3321 23.8334 30.3333H8.66673Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" />
                                    <path d="M42.5151 15.391L6.44606 37.7298" stroke="#E0ECFA" stroke-width="2.5" stroke-linecap="square" stroke-linejoin="round" />
                                </svg>
                                <h3>Faster Browsing</h3>
                                <p>Enhanced performance without the drag of unnecessary trackers or ads.</p>
                            </div>
                            <div className="cardonebenifits"  ref={(el) => (cardRefs.current[3] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg4.png" alt="" />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M27.6665 9.3335H15.6665" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                    <path d="M16.2661 22.6665H4.26611" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                    <path d="M22.6665 26.6666C24.8756 26.6666 26.6665 24.8758 26.6665 22.6666C26.6665 20.4575 24.8756 18.6666 22.6665 18.6666C20.4574 18.6666 18.6665 20.4575 18.6665 22.6666C18.6665 24.8758 20.4574 26.6666 22.6665 26.6666Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9.3335 13.3334C11.5426 13.3334 13.3335 11.5425 13.3335 9.33337C13.3335 7.12424 11.5426 5.33337 9.3335 5.33337C7.12436 5.33337 5.3335 7.12424 5.3335 9.33337C5.3335 11.5425 7.12436 13.3334 9.3335 13.3334Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <h3>Customizable Protection</h3>
                                <p>Choose the level of security and privacy that suits your needs.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Benifits